export default function IntakeSubmitted() {
  return (
    <div className="page">
      <h2>Intake Submitted</h2>
      <p>Your project request has been received.</p>
      <p>Our team will review and follow up shortly.</p>
      <a href="/dashboard" className="btn primary">Go to Dashboard</a>
    </div>
  );
}
